import 'ol/ol.css';
import Feature from 'ol/Feature';
import Map from 'ol/Map';
import Point from 'ol/geom/Point';
import View from 'ol/View';
import {
  Circle as CircleStyle,
  Fill,
  Style,
  Text,
  Icon,
} from 'ol/style';
import XYZ from 'ol/source/XYZ';
import {Cluster, OSM, Vector as VectorSource} from 'ol/source';
import {Tile as TileLayer, Vector as VectorLayer} from 'ol/layer';
import {boundingExtent} from 'ol/extent';
import {fromLonLat} from 'ol/proj';
import * as olInteraction from 'ol/interaction';

/** viewに仕込んである情報を取得する */
let map_doc = document.getElementById('map_data');

// Controllerから経緯度を取得
let map_json = map_doc.getAttribute('data-map-id');
let map_data = JSON.parse(map_json);

let features = [];
for (let i = 0; i < map_data.length; i++) {
  let lon = parseFloat(map_data[i][1]);
  let lat = parseFloat(map_data[i][2]);
  features[i] = new Feature({
    geometry: new Point(fromLonLat([lon, lat])),
    name: map_data[i][0]
  });
}

const source = new VectorSource({
  features: features,
});

const clusterSource = new Cluster({
  // distance: default:20,
  // minDistance: default:0
  source: source,
});



const styleCache = {};
const clusters = new VectorLayer({
  source: clusterSource,
  style: function (feature) {
    const size = feature.get('features').length;
    let style = styleCache[size];
    if (!style) {
      style = new Style({
        image: new Icon({
          anchor: [0.5, 1],
          anchorXUnits: 'fraction',
          anchorYUnits: 'fraction',
          src: '../assets/pin.png',
        }),
        text: new Text({
          text: size.toString(),
          scale: 1.5,
          offsetY: -34,
          fill: new Fill({
            color: '#000',
          }),
        }),
      });
      styleCache[size] = style;
    }
    return style;
  },
});


const raster = new TileLayer({
  title: "地理院地図",
  type: "overlay",
  source: new XYZ({
    attributions:
      "<a href='https://maps.gsi.go.jp/development/ichiran.html' target='_blank'>地理院タイル</a>", //出典の表記
    url: "https://cyberjapandata.gsi.go.jp/xyz/std/{z}/{x}/{y}.png",
    projection: "EPSG:3857" // CRS指定
  })  
});
let lonlat = fromLonLat([137.69, 37.97], "EPSG:3857");

const map = new Map({
  interactions:
  olInteraction.defaults({
    altShiftDragRotate: false,
    pinchRotate: false,
  }), 
  layers: [raster, clusters],
  target: 'search_map',
  view: new View({
    center: lonlat,
    zoom: 4.5,
  }),
});

let onclick = false;
map.on('click', (e) => {
  clusters.getFeatures(e.pixel).then((clickedFeatures) => {
    if (onclick) return;
    if (clickedFeatures.length) {
      onclick = true;
      // Get clustered Coordinates
      document.getElementById("search_map").setAttribute("disabled", true);
      const features = clickedFeatures[0].get('features');
      let post_ids = [];

      for(let i = 0; i < features.length; i++) {
        post_ids[i] = features[i].values_.name;
      }

      // ピンをクリックしたときにズームする
      // if (features.length > 1) {
      //   const extent = boundingExtent(
      //     features.map((r) => r.getGeometry().getCoordinates())
      //   );
      //   map.getView().fit(extent, {minResolution:10, duration: 1000, padding: [150, 150, 150, 150]});
      // }

      if(post_ids.length) {
        $.ajax({
          url: "search_map",
          type: "GET",
          data: {
            post_ids,
            request: 'search_request',
          },
        }).done(function(data) {
          $('.post_container').children().remove();            
          $('.post_container').html(data);
          $('body, html').animate({ scrollTop: 0 }, 100);
        }).fail(function() {
        }).always(function(){
          onclick = false;
        });
      }
    }
  });
});

function link_active() {
  $('.menu_active').removeClass('link_active');
  $('.detail_search_link').addClass('link_active');
}
$(function () {
  link_active();
});
